import { AccountTypeENUM, Manufacturer } from 'models/account.model';
import { CustomPricingMap, OfferPricingMapDealer, OfferPricingMapManufacturer, PricingElementName, PricingMapDealer, PricingMapManufacturer } from 'models/pricing.model';

/** For writing */
export const MANUFACTURER_OFFER_PRICING_MAP: OfferPricingMapManufacturer = {
  sellDiscount: '2070.01',
  sellVat: '2080.01',
  tz: '990.06'
};

/** For writing */
export const DEALER_OFFER_PRICING_MAP: OfferPricingMapDealer = {
  manufacturerAdditionalDiscount: '990.02',
  manufacturerAlternativeDiscount: '990.03',
  manufacturerPositionDiscount: '990.05',
  listPriceDiscount: '990.08',
  buyPriceSurcharge: '990.09',
  sellDiscount: '2090.01',
  sellVat: '2110.00',
  totalNetSellPrice: '2100.00'
};

/** For writing */
export const CUSTOM_PRICING_MAP: CustomPricingMap = {
  listPrice: '1450.00',
  basePrice: '1460.00',
  alternativeDiscount: '1430.00'
};

/** For writing */
export const FREE_PRICING_MAP: CustomPricingMap = {
  listPrice: '1400.01',
  basePrice: '1450.00',
  alternativeDiscount: '1430.00'
};

const DEALER_PRICING_MAP: any = {
  listPrice: { stepId: '2000.00', key: 'rate' },
  basePrice: { stepId: '2070.00', key: 'rate' },
  totalBasePrice: { stepId: '3000.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '3100.00', key: 'conditionValue' },
  totalLpAndTzPlusBOM: { stepId: '3200.00', key: 'conditionValue' }
};


const DEALER_PRICING_ELEMENT_10X: any = {
  listPrice: { stepId: '1000.00', key: 'rate' },
  listPriceDiscount: { stepId: '1080.00', key: 'rate' },
  buyPriceSurcharge: { stepId: '1080.01', key: 'rate' },
  basePrice: { stepId: '1070.00', key: 'rate' },
  totalBasePrice: { stepId: '1070.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '1090.00', key: 'conditionValue' },
  sellPrice: { stepId: '1090.00', key: 'rate' },
  baseDiscount: { stepId: '1010.00', key: 'rate' },
  additionalDiscount: { stepId: '1020.00', key: 'rate' },
  alternativeDiscount: { stepId: '1030.00', key: 'rate' },
  positionDiscount: { stepId: '1030.01', key: 'rate' },
  tz: { stepId: '1005.00', key: 'rate' },
  listPriceWithTz: { stepId: '1035.00', key: 'rate' },
  profitMargin: { stepId: '1095.00', key: 'rate' }
};

const DEALER_PRICING_ELEMENT_11X: any = {
  listPrice: { stepId: '1100.00', key: 'rate' },
  listPriceDiscount: { stepId: '1180.00', key: 'rate' },
  buyPriceSurcharge: { stepId: '1180.01', key: 'rate' },
  basePrice: { stepId: '1170.00', key: 'rate' },
  totalBasePrice: { stepId: '1170.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '1190.00', key: 'conditionValue' },
  sellPrice: { stepId: '1090.00', key: 'rate' },
  baseDiscount: { stepId: '1110.00', key: 'rate' },
  additionalDiscount: { stepId: '1120.00', key: 'rate' },
  alternativeDiscount: { stepId: '1130.00', key: 'rate' },
  positionDiscount: { stepId: '1130.01', key: 'rate' },
  tz: { stepId: '1105.00', key: 'rate' },
  listPriceWithTz: { stepId: '1135.00', key: 'rate' },
  profitMargin: { stepId: '1195.00', key: 'rate' }
};

const DEALER_PRICING_ELEMENT_12X: any = {
  listPrice: { stepId: '1200.00', key: 'rate' },
  listPriceDiscount: { stepId: '1280.00', key: 'rate' },
  buyPriceSurcharge: { stepId: '1280.01', key: 'rate' },
  basePrice: { stepId: '1270.00', key: 'rate' },
  totalBasePrice: { stepId: '1270.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '1290.00', key: 'conditionValue' },
  sellPrice: { stepId: '1290.00', key: 'rate' },
  baseDiscount: { stepId: '1210.00', key: 'rate' },
  additionalDiscount: { stepId: '1220.00', key: 'rate' },
  alternativeDiscount: { stepId: '1230.00', key: 'rate' },
  positionDiscount: { stepId: '1230.01', key: 'rate' },
  tz: { stepId: '1205.00', key: 'rate' },
  listPriceWithTz: { stepId: '1235.00', key: 'rate' },
  profitMargin: { stepId: '1295.00', key: 'rate' }
};

const DEALER_PRICING_ELEMENT_13X: any = {
  listPrice: { stepId: '1300.00', key: 'rate' },
  listPriceDiscount: { stepId: '1380.00', key: 'rate' },
  buyPriceSurcharge: { stepId: '1380.01', key: 'rate' },
  basePrice: { stepId: '1370.00', key: 'rate' },
  totalBasePrice: { stepId: '1370.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '1390.00', key: 'conditionValue' },
  sellPrice: { stepId: '1390.00', key: 'rate' },
  baseDiscount: { stepId: '1310.00', key: 'rate' },
  additionalDiscount: { stepId: '1320.00', key: 'rate' },
  alternativeDiscount: { stepId: '1330.00', key: 'rate' },
  positionDiscount: { stepId: '1330.01', key: 'rate' },
  tz: { stepId: '1305.00', key: 'rate' },
  listPriceWithTz: { stepId: '1335.00', key: 'rate' },
  profitMargin: { stepId: '1395.00', key: 'rate' }
};

const DEALER_PRICING_ELEMENT_14X: any = {
  listPrice: { stepId: '1400.00', key: 'rate' },
  listPriceDiscount: { stepId: '1480.00', key: 'rate' },
  buyPriceSurcharge: { stepId: '1480.01', key: 'rate' },
  basePrice: { stepId: '1470.00', key: 'rate' },
  totalBasePrice: { stepId: '1470.00', key: 'conditionValue' },
  totalSellPrice: { stepId: '1490.00', key: 'conditionValue' },
  sellPrice: { stepId: '1490.00', key: 'rate' },
  baseDiscount: { stepId: '1410.00', key: 'rate' },
  additionalDiscount: { stepId: '1420.00', key: 'rate' },
  alternativeDiscount: { stepId: '1430.00', key: 'rate' },
  positionDiscount: { stepId: '1430.01', key: 'rate' },
  tz: { stepId: '1405.00', key: 'rate' },
  listPriceWithTz: { stepId: '1435.00', key: 'rate' },
  profitMargin: { stepId: '1495.00', key: 'rate' }
};

const GARANT_DEALER_PRICING_MAP: PricingMapDealer = {
  ...DEALER_PRICING_MAP,
  elements: {
    [PricingElementName.DOOR]: DEALER_PRICING_ELEMENT_10X,
    [PricingElementName.DOOR2]: DEALER_PRICING_ELEMENT_11X,
    [PricingElementName.PANEL]: DEALER_PRICING_ELEMENT_12X,
    [PricingElementName.FRAME]: DEALER_PRICING_ELEMENT_13X,
    [PricingElementName.LOOSE]: DEALER_PRICING_ELEMENT_14X,
    [PricingElementName.FRAME2]: undefined,
    [PricingElementName.FRAME3]: undefined,
  }
}
const PRUEM_DEALER_PRICING_MAP: PricingMapDealer = {
  ...DEALER_PRICING_MAP,
  elements: {
    [PricingElementName.FRAME]: DEALER_PRICING_ELEMENT_10X,
    [PricingElementName.DOOR]: DEALER_PRICING_ELEMENT_11X,
    [PricingElementName.FRAME2]: DEALER_PRICING_ELEMENT_12X,
    [PricingElementName.FRAME3]: DEALER_PRICING_ELEMENT_13X,
    [PricingElementName.LOOSE]: DEALER_PRICING_ELEMENT_14X,
    [PricingElementName.DOOR2]: undefined,
    [PricingElementName.PANEL]: undefined,
  }
}

const MANUFACTURER_PRICING_ELEMENT_10X: any = {
  listPrice: { stepId: '1000.00', key: 'rate' },
  basePrice: { stepId: '1070.00', key: 'rate' },
  totalSellPrice: { stepId: '1070.00', key: 'conditionValue' },
  sellPrice: { stepId: '1070.00', key: 'rate' },
  baseDiscount: { stepId: '1010.00', key: 'rate' },
  additionalDiscount: { stepId: '1020.00', key: 'rate' },
  alternativeDiscount: { stepId: '1030.00', key: 'rate' },
  positionDiscount: { stepId: '1030.01', key: 'rate' },
  tz: { stepId: '1005.00', key: 'rate' },
  listPriceWithTz: { stepId: '1035.00', key: 'rate' }
};

const MANUFACTURER_PRICING_ELEMENT_11X: any = {
  listPrice: { stepId: '1100.00', key: 'rate' },
  basePrice: { stepId: '1170.00', key: 'rate' },
  totalSellPrice: { stepId: '1170.00', key: 'conditionValue' },
  sellPrice: { stepId: '1170.00', key: 'rate' },
  baseDiscount: { stepId: '1110.00', key: 'rate' },
  additionalDiscount: { stepId: '1120.00', key: 'rate' },
  alternativeDiscount: { stepId: '1130.00', key: 'rate' },
  positionDiscount: { stepId: '1130.01', key: 'rate' },
  tz: { stepId: '1105.00', key: 'rate' },
  listPriceWithTz: { stepId: '1135.00', key: 'rate' }
};

const MANUFACTURER_PRICING_ELEMENT_12X: any = {
  listPrice: { stepId: '1200.00', key: 'rate' },
  basePrice: { stepId: '1270.00', key: 'rate' },
  totalSellPrice: { stepId: '1270.00', key: 'conditionValue' },
  sellPrice: { stepId: '1270.00', key: 'rate' },
  baseDiscount: { stepId: '1210.00', key: 'rate' },
  additionalDiscount: { stepId: '1220.00', key: 'rate' },
  alternativeDiscount: { stepId: '1230.00', key: 'rate' },
  positionDiscount: { stepId: '1230.01', key: 'rate' },
  tz: { stepId: '1205.00', key: 'rate' },
  listPriceWithTz: { stepId: '1235.00', key: 'rate' }
};

const MANUFACTURER_PRICING_ELEMENT_13X: any = {
  listPrice: { stepId: '1300.00', key: 'rate' },
  basePrice: { stepId: '1370.00', key: 'rate' },
  totalSellPrice: { stepId: '1370.00', key: 'conditionValue' },
  sellPrice: { stepId: '1370.00', key: 'rate' },
  baseDiscount: { stepId: '1310.00', key: 'rate' },
  additionalDiscount: { stepId: '1320.00', key: 'rate' },
  alternativeDiscount: { stepId: '1330.00', key: 'rate' },
  positionDiscount: { stepId: '1330.01', key: 'rate' },
  tz: { stepId: '1305.00', key: 'rate' },
  listPriceWithTz: { stepId: '1335.00', key: 'rate' }
};

const MANUFACTURER_PRICING_ELEMENT_14X: any = {
  listPrice: { stepId: '1400.00', key: 'rate' },
  basePrice: { stepId: '1470.00', key: 'rate' },
  totalSellPrice: { stepId: '1470.00', key: 'conditionValue' },
  sellPrice: { stepId: '1470.00', key: 'rate' },
  baseDiscount: { stepId: '1410.00', key: 'rate' },
  additionalDiscount: { stepId: '1420.00', key: 'rate' },
  alternativeDiscount: { stepId: '1430.00', key: 'rate' },
  positionDiscount: { stepId: '1430.01', key: 'rate' },
  tz: { stepId: '1405.00', key: 'rate' },
  listPriceWithTz: { stepId: '1435.00', key: 'rate' }
};

const MANUFACTURER_PRICING_MAP: any = {
  listPrice: { stepId: '2000.00', key: 'rate' },
  basePrice: { stepId: '2070.00', key: 'rate' },
  totalSellPrice: { stepId: '3000.00', key: 'conditionValue' },
  totalLpAndTzPlusBOM: { stepId: '3200.00', key: 'conditionValue' }
};


const GARANT_MANUFACTURER_PRICING_MAP: PricingMapManufacturer = {
  ...MANUFACTURER_PRICING_MAP,
  elements: {
    [PricingElementName.DOOR]: MANUFACTURER_PRICING_ELEMENT_10X,
    [PricingElementName.DOOR2]: MANUFACTURER_PRICING_ELEMENT_11X,
    [PricingElementName.PANEL]: MANUFACTURER_PRICING_ELEMENT_12X,
    [PricingElementName.FRAME]: MANUFACTURER_PRICING_ELEMENT_13X,
    [PricingElementName.LOOSE]: MANUFACTURER_PRICING_ELEMENT_14X,
    [PricingElementName.FRAME2]: undefined,
    [PricingElementName.FRAME3]: undefined,
  }
}
const PRUEM_MANUFACTURER_PRICING_MAP: PricingMapManufacturer = {
  ...MANUFACTURER_PRICING_MAP,
  elements: {
    [PricingElementName.FRAME]: MANUFACTURER_PRICING_ELEMENT_10X,
    [PricingElementName.DOOR]: MANUFACTURER_PRICING_ELEMENT_11X,
    [PricingElementName.FRAME2]: MANUFACTURER_PRICING_ELEMENT_12X,
    [PricingElementName.FRAME3]: MANUFACTURER_PRICING_ELEMENT_13X,
    [PricingElementName.LOOSE]: MANUFACTURER_PRICING_ELEMENT_14X,
    [PricingElementName.DOOR2]: undefined,
    [PricingElementName.PANEL]: undefined,
  }
}

export const TENANT_PRICING_MAP = {
  [Manufacturer.GARANT]: {
    [AccountTypeENUM.MANUFACTURER]: GARANT_MANUFACTURER_PRICING_MAP,
    [AccountTypeENUM.DEALER]: GARANT_DEALER_PRICING_MAP
  },
  [Manufacturer.PRUEM]: {
    [AccountTypeENUM.MANUFACTURER]: PRUEM_MANUFACTURER_PRICING_MAP,
    [AccountTypeENUM.DEALER]: PRUEM_DEALER_PRICING_MAP
  }
};
